<template lang="pug">
.caseDialogue(v-disabled="seeState")
  .Dialogue-box
    Form(:model="question")
      .Dialogue-stem
        Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
          @click='showAIDialog()',v-if='enableAI') AI生成
        Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
          Form(:model="aiForm" :label-width="80")
            FormItem(label="生成数量" v-if="false")
              InputNumber(v-model="aiForm.count" :min="1" :max="1" placeholder="请输入生成数量")
            FormItem(label="对话轮数")
              InputNumber(v-model="aiForm.dialogue_count" :min="1" :max="6" placeholder="请输入对话轮数")
            FormItem(label='提示词',prop="stem")
              Input(v-model='aiForm.system' placeholder='请填写提示词'
                type="textarea" :rows="3")
        .title 对话设置
        iDelModel.ide(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
      .Dialogue-metas
        FormItem(:label-width="80" v-for='(item,index) in question.metas',:key='index')
          Row(:gutter="16")
            Col(span="4")
              Select(placeholder="请选择" v-model='item.name' filterable allow-create @on-create="handleCreate")
                Option(v-for="app in taData" :key="app.key" :value="app.title") {{ app.title }}
            Col(span="12")
              Input(type='textarea' v-model="item.content" :rows="2" placeholder="请填写谈话内容" ).rolecontent
            Col(v-if="index > 1" span="6")
              Icon(type="ios-close-circle",@click='delMeta(index)')
        FormItem(:label-width="80")
          Button(type="primary" ghost @click='handleAddMeta') + 添加
      //-     Button.button(@click='addMeta2',
      //- style='color:#3A76D2;border: 1px solid #3A76D2;text-align:left;margin-left: 0px;') + 添加分析师讲话
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
import { cloneDeep } from "lodash";
import Bus from "../../utils/bus";
export default {
  components: {
    iDelModel
  },
  props: ["data", "haId", "taskId", "enableAI"],
  inject: ["seeState"],

  data() {
    return {
      rolestatus: false,
      taData: [
        {
          title: "领导",
          key: "a"
        },
        {
          title: "分析师",
          key: "b"
        }
      ],
      question: {
        metas: [
          { name: "领导", content: "" },
          { name: "分析师", content: "" }
        ],
        stem: "该案例此字段废弃！"
      },
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, dialogue_count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "DIALOGUE",
          count: this.aiForm.count,
          dialogue_count: this.aiForm.dialogue_count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
              Bus.$emit("refresh-task", this.taskId);
          } else {
              this.$emit("refresh-query");
          }
        }
      });
    },
    addMeta() {
      // 添加选项
      this.question.metas.push({ name: "领导", content: "" });
    },
    addMeta2() {
      // 添加选项
      this.question.metas.push({ name: "分析师", content: "" });
    },
    handleAddMeta() {
      this.question.metas.push({ name: "领导", content: "" });
    },
    handleCreate(val) {
      this.taData.push({ title: val, key: Math.floor(Math.random() * 1000000) });
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    },
    delMeta(index) {
      // 删除选项
      if (this.question.metas.length > 1) {
        this.question.metas = this.question.metas.filter((val, i) => i !== index);
      } else {
        return this.$Message.error("至少保留一条选项");
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
        this.taData = cloneDeep(this.data.metas).map((v) => {
          return {
            title: v.name,
            key: `${v.name}sd`
          };
        });
        console.log(cloneDeep(this.data.metas), "this.data.metas");
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="stylus">
.ivu-select-selection
  height auto!important
  overflow auto
.caseDialogue
  .Dialogue-box
    padding 24px 0
    .Dialogue-stem
      position relative
      margin-bottom 16px
      .title
        width 56px
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 1)
        line-height 18px
      .ivu-form-item-content
        margin-right 300px
      .btns
        position absolute
        top -5px
        right 0
        .ivu-icon
          color #3A76D2FF
          font-size 22px
          top 0
          margin-right 12px
          background #F2F5FAFF
          width 24px
          height 24px
          border-radius 4px
          text-align center
          line-height @height
          &:hover
            cursor pointer
    .Dialogue-metas
      .ivu-form-item-label
       font-size 14px
       text-align left
      .code-row-bg:before
        display none
      .button
        float left
        margin 0!important
        color #3a76d2
      .ivu-form-item-content
        margin-right 25px
        position relative
        .ivu-icon-ios-close-circle
          font-size 22px
          position absolute
          top 6px
          color #E72020FF
          &:hover
            cursor pointer
</style>
